import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("aethel_wishlist")) || [];
    } catch {
      return [];
    }
  });
  const synced = useRef(false);

  useEffect(() => {
    localStorage.setItem("aethel_wishlist", JSON.stringify(ids));
  }, [ids]);

  // On login, merge local hearts with the server-saved wishlist
  useEffect(() => {
    if (!user) {
      synced.current = false;
      return;
    }
    if (synced.current) return;
    synced.current = true;
    api
      .get("/wishlist")
      .then((r) => {
        setIds((local) => {
          const merged = [...new Set([...local, ...(r.data.product_ids || [])])];
          api.put("/wishlist", { product_ids: merged }).catch(() => {});
          return merged;
        });
      })
      .catch(() => {});
  }, [user]);

  const toggle = (productId) => {
    setIds((prev) => {
      const next = prev.includes(productId)
        ? prev.filter((i) => i !== productId)
        : [...prev, productId];
      if (user) api.put("/wishlist", { product_ids: next }).catch(() => {});
      return next;
    });
  };

  const has = (productId) => ids.includes(productId);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}
